<template>
    <main class="main">
        <div class="container-fluid px-0" data-layout="container">

            <aside-main/>

            <header-main/>

            <div class="content">

                <div class="card-header mb-5 d-flex flex-between-center">
                    <div class="d-flex align-items-center">
                        <h2>Главная</h2>
                    </div>
                </div>

                <div class="card-body p-0 spinner-center" v-if="preloader">
                    <div class="p-4 code-to-copy">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>

                <div class="row g-5" v-if="!preloader">
                    <div class="col-xl-12 mb-5">
                        <form class="row g-3" v-on:submit.prevent="update">

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.date"
                                        @input="errors.date = null"
                                        :class="{'is-invalid': errors.date}"
                                        placeholder="Время сутки"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Время сутки</label>
                                    <div class="invalid-feedback">{{errors.date}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.name"
                                        @input="errors.name = null"
                                        :class="{'is-invalid': errors.name}"
                                        placeholder="Имя"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Имя</label>
                                    <div class="invalid-feedback">{{errors.name}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.balance"
                                        @input="errors.balance = null"
                                        :class="{'is-invalid': errors.balance}"
                                        placeholder="Баланс"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Баланс</label>
                                    <div class="invalid-feedback">{{errors.balance}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.mounth"
                                        @input="errors.mounth = null"
                                        :class="{'is-invalid': errors.mounth}"
                                        placeholder="Месяц"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Месяц</label>
                                    <div class="invalid-feedback">{{errors.mounth}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.all_spends"
                                        @input="errors.all_spends = null"
                                        :class="{'is-invalid': errors.all_spends}"
                                        placeholder="Все расходы"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Все расходы</label>
                                    <div class="invalid-feedback">{{errors.all_spends}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input
                                        v-model="data.people_transfers"
                                        @input="errors.people_transfers = null"
                                        :class="{'is-invalid': errors.people_transfers}"
                                        placeholder="Переводы людям"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Переводы людям</label>
                                    <div class="invalid-feedback">{{errors.people_transfers}}</div>
                                </div>
                            </div>



                            <div class="card-header p-2 mt-4 d-flex flex-between-center" style="margin-bottom: -10px;">
                                <div class="d-flex align-items-center">
                                    <h2 class="fs-1">Переводы</h2>
                                </div>

                                <div class="d-flex">
                                    <a 
                                        @click="newTransfer"
                                        class="btn btn-primary mb-1 float_right">Новый перевод</a>
                                </div>
                            </div>

                            <template v-for="(item, index) in data.transfers">
                                <div class="col-sm-6 col-md-5">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.transfers[index].firstname"
                                            placeholder="Имя"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Имя</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-5">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.transfers[index].lastname"
                                            placeholder="Фамилия"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Фамилия</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-2">
                                    <div class="form-floating v-select-medium select-both-button-row">
                                        <button
                                            style="height: 48px"
                                            @click="changeTransferStatus(index)"
                                            :content="data.transfers[index].status == 1 ? 'Отключить' : 'Включить'" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-secondary select-button-right">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular" :class="{'fa-circle-pause': data.transfers[index].status == 1, 'fa-play': data.transfers[index].status == 0}"></i>
                                            </span>
                                        </button>

                                        <button
                                            style="height: 48px"
                                            :disabled="data.transfers.length == 1"
                                            @click="deleteTransfer(index)"
                                            content="Удалить" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-danger select-button-right-2">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular fa-trash"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </template>



                            <div class="card-header p-2 mt-4 d-flex flex-between-center" style="margin-bottom: -10px;">
                                <div class="d-flex align-items-center">
                                    <h2 class="fs-1">Карты</h2>
                                </div>

                                <div class="d-flex">
                                    <a 
                                        @click="newCard"
                                        class="btn btn-primary mb-1 float_right">Новая карта</a>
                                </div>
                            </div>

                            <template v-for="(item, index) in data.cards">
                                <div class="col-sm-6 col-md-4">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.cards[index].number_card"
                                            placeholder="Номер карты"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Номер карты</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-3">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.cards[index].balance"
                                            placeholder="Баланс"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Баланс</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-3">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.cards[index].number_account"
                                            placeholder="Номер счета"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Номер счета</label>
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-2">
                                    <div class="form-floating v-select-medium select-both-button-row">
                                        <button
                                            style="height: 48px"
                                            @click="changeCardStatus(index)"
                                            :content="data.cards[index].status == 1 ? 'Отключить' : 'Включить'" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-secondary select-button-right">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular" :class="{'fa-circle-pause': data.cards[index].status == 1, 'fa-play': data.cards[index].status == 0}"></i>
                                            </span>
                                        </button>

                                        <button
                                            style="height: 48px"
                                            :disabled="data.cards.length == 1"
                                            @click="deleteCard(index)"
                                            content="Удалить" 
                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                            type="button"
                                            class="btn btn-soft-danger select-button-right-2">
                                            <span class="vertical-center-icon">
                                                <i class="icon-paysystem fa-regular fa-trash"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </template>

                            <div class="col-sm-3 col-md-3">
                                <button class="btn btn-primary px-5 w-100 text-nowrap" type="submit" :class="{'disabled': btn_preloader}">
                                    <span class="spinner-border spinner-border-sm spinner-border-custom" role="status" v-if="btn_preloader"></span>
                                    <span>Сохранить</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                
                <footer-main/>

            </div>

        </div>
    </main>
</template>

<script>
export default {
    props: ['id'],
    data () {
        return {
            preloader: true,
            btn_preloader: false,
            data: {
                date: null,
                name: null,
                balance: null,
                mounth: null,
                all_spends: null,
                people_transfers: null,
                cards: [
                    {
                        number_card: null,
                        balance: null,
                        number_account: null,
                        status: 1
                    }
                ],
                transfers: [
                    {
                        firstname: null,
                        lastname: null,
                        status: 1
                    }
                ]
            },
            errors: {
                date: null,
                name: false,
                balance: false,
                mounth: null,
                all_spends: null,
                people_transfers: null,
                cards: [
                    {
                        number_card: false,
                        balance: false,
                        number_account: false,
                        status: false
                    }
                ]
            }
        }
    },
    methods: {
        getItem () {
            this.$axios.post('/sberbank/item/home')
            .then(async (response) => {
                this.preloader = false
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':

                        this.data = response.data

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        update () {
            this.btn_preloader = true
            this.$axios.post('/sberbank/home/update', JSON.stringify(this.data))
            .then((response) => {
                this.btn_preloader = false
                response = response.data
                switch (response.status) {
                    case "error":
                        this.$toast.error(response.message)
                        break
                    case "success":
                        this.$toast.success(response.message)

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                this.btn_preloader = false
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    if('field' in response) {
                        this.errorByPatch(this.errors, response.field, response.message)
                    } else {
                        this.$toast.error(response.message)
                    }
                }
            })
        },
        errorByPatch (layer, path, value) {
            path = path.split('.')

            path.forEach((value, index) => {
                if (!isNaN(value)) {
                    path[index] = parseInt(value)
                }
            })

            for (var i = 0; i < path.length; i++) {
                if (value != null && i + 1 === path.length) {
                    layer[path[i]] = value
                }
                layer = layer[path[i]]
            }
            return layer
        },
        newCard () {
            this.data.cards.push({
                number_card: null,
                balance: null,
                number_account: null,
                status: 1
            })

            this.errors.cards.push({
                number_card: false,
                balance: false,
                number_account: false,
                status: false
            })
        },
        deleteCard (index) {
            if(this.data.cards.length > 1) {
                this.data.cards.splice(index, 1)
            }
        },
        changeCardStatus (index) {
            this.data.cards[index].status = this.data.cards[index].status ? 0 : 1
        },

        newTransfer () {
            this.data.transfers.push({
                firstname: null,
                lastname: null,
                status: 1
            })
        },
        deleteTransfer (index) {
            if(this.data.transfers.length > 1) {
                this.data.transfers.splice(index, 1)
            }
        },
        changeTransferStatus (index) {
            this.data.transfers[index].status = this.data.transfers[index].status ? 0 : 1
        }
    },
    beforeMount() {
        this.getItem()
    }
}
</script>

<style lang="css" scoped>
    ::v-deep .vs__clear {
        display: none;
    }
</style>
